module.exports = __webpack_public_path__ + "img/Tiktok.a0a59ee2.svg";